// 校验邮箱
export const emailReg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$")

// 手机号(以1开头的11位数字)
export const phoneReg = new RegExp("^1\\d{10}$")

// 密码(8-20位,含大小写字母和数字)
export const passwordReg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\dA-Za-z]{8,20}$/

// 支付密码
export const payPasswordReg = new RegExp("^\\d{6}$")

// 营业执照
export const businessLicenseReg = new RegExp("^[a-zA-Z\\d]{15}$")

// 身份证
export const idCardReg = new RegExp("(^\\d{15}$)|(^\\d{18}$)|(^\\d{17}(\\d|X|x)$)")
